import { MessageMedium } from '../../domain';
import { ExtendedChannel, ExtendedMessageType } from '../types';
import { aggregateChannelIds } from './aggregateChannelIds';
import { filterByMessageChannelIds } from './filterByMessageChannelIds';

const byMedium =
  (media: MessageMedium[]) =>
  ({ messageMedium }: ExtendedChannel) =>
    media.includes(messageMedium);

export const filterByMedium = (
  media: MessageMedium[],
  channels: ExtendedChannel[],
  messageTypes: ExtendedMessageType[],
): [ExtendedChannel[], ExtendedMessageType[]] => {
  // Find matching message types + channels
  const filteredChannels = channels.filter(byMedium(media));

  // Include message types under channels that have matching mediums
  const matchingChannelIds = aggregateChannelIds([], filteredChannels);

  return [filteredChannels, filterByMessageChannelIds(messageTypes, matchingChannelIds)];
};
